import React from 'react'
import { Row } from 'antd'
import 'react-calendar/dist/Calendar.css';
import Content from './LandingContent';
import ContentLeft from './ContentLeft'

const ReservationView = ({
    language,
    reservationList,
    reservationItems,
    activeItem,
    calendarDate
}) => {
    return (
        <>
            <Row className="container">
                <ContentLeft
                    language={language}
                    reservationList={reservationList}
                    reservationItems={reservationItems}
                    activeItem={activeItem}
                    calendarDate={calendarDate}
                />
                <Content
                    reservationItems={reservationItems}
                    activeItem={activeItem}
                />
            </Row>
        </>
    )
}

export default ReservationView